export default __webpack_public_path__ + "static/media/svg-2.fb34603e.svg";